<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah Komisaris Data</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Jabatan</div>
          <input class="lv3-input-text" type="text" v-model="jabatanKomisaris" disabled />
        </div>
        <div class="edit-form-wrapper">
          <div>Nama<span class="text-ast">*</span></div>
          <input class="lv3-input-text" type="text" v-model="namaKomisaris"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Handphone<span class="text-ast">*</span></div>
          <div class="vendor-form">
            <!-- <input class="lv3-input-text" type="text" v-model="phoneDirektur" /> -->
            <div class="phone-add">
              <the-mask class="phone-add__phone" :mask="['+## ####################']"
                v-model="$store.state.landingpage.phoneKomisaris" />
            </div>
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Email<span class="text-ast">*</span></div>
          <input class="lv3-input-text" type="text" v-model="emailKomisaris"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Upload KTP<span class="text-ast">*</span></div>
          <div class="column50">
            <label class="lv3-input-text">
              <i class="fas fa-upload"></i>
              <span>{{ komisarisFileName }}</span>
              <input type="file" style="display: none;" @change="fileKomisarisChangeHandler" />
            </label>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      jabatan: '',
      nama: '',
      phoneNumber: '',
      email: '',
    }
  },
  computed: {
    jabatanKomisaris: {
      get: function () {
        if (this.$store.state.landingpage.addKomisaris) {
          if (this.$store.state.landingpage.komisarisList.length == 0) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'jabatanKomisaris',
              value: 'KOMISARIS UTAMA',
            })
          } else {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'jabatanKomisaris',
              value: 'KOMISARIS',
            })
          }
        }
        return this.$store.state.landingpage.jabatanKomisaris
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'jabatanKomisaris',
          value: newValue,
        })
      },
    },
    namaKomisaris: {
      get: function () {
        return this.$store.state.landingpage.namaKomisaris
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'namaKomisaris',
          value: newValue,
        })
      },
    },
    emailKomisaris: {
      get: function () {
        return this.$store.state.landingpage.emailKomisaris
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'emailKomisaris',
          value: newValue,
        })
      },
    },
    komisarisFileName() {
      const {
        komisarisFiles,
        komisarisLampiran,
      } = this.$store.state.landingpage

      if (
        komisarisFiles &&
        komisarisFiles.length > 0 &&
        'name' in komisarisFiles[0]
      ) {
        return komisarisFiles[0].name
      }

      if (komisarisLampiran) {
        return komisarisLampiran
      }
      return this.labelPlaceholder
    },
  },
  methods: {
    submitForm() {
      if (this.checkForm()) {
        this.confirm()
      }
    },
    checkForm() {
      let arr = [
        [this.namaKomisaris, 'Nama Komisaris'],
        [this.$store.state.landingpage.phoneKomisaris.length > 3, 'No Telepon'],
        [
          this.isEmailValid(this.$store.state.landingpage.emailKomisaris),
          'Email',
        ],
      ]

      if (!this.$get(this.$store, 'state.landingpage.komisarisLampiran')) {
        arr = [
          ...arr,
          [this.$store.state.landingpage.komisarisFiles.length > 0, 'KTP'],
        ]
      }

      return this.multiConditions(arr)
    },
    closeModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomisaris',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editKomisaris',
        value: false,
      })
    },
    confirm() {
      if (this.$store.state.landingpage.addKomisaris) {
        let komisarisData = {
          id: this.$store.state.landingpage.komisarisIndex + 1,
          jabatan: this.$store.state.landingpage.jabatanKomisaris,
          nama: this.$store.state.landingpage.namaKomisaris,
          phoneNumber: this.$store.state.landingpage.phoneKomisaris,
          email: this.$store.state.landingpage.emailKomisaris,
          komisarisFiles: this.$store.state.landingpage.komisarisFiles,
        }

        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'komisarisList',
          value: komisarisData,
          operation: 'add',
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'komisarisIndex',
          value: komisarisData.id + 1,
        })
      } else if (this.$store.state.landingpage.editKomisaris) {
        let komisarisData = {
          id: this.$store.state.landingpage.idKomisaris,
          jabatan: this.$store.state.landingpage.jabatanKomisaris,
          nama: this.$store.state.landingpage.namaKomisaris,
          phoneNumber: this.$store.state.landingpage.phoneKomisaris,
          email: this.$store.state.landingpage.emailKomisaris,
          komisarisFiles: this.$store.state.landingpage.komisarisFiles,
        }
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'komisarisList',
          value: komisarisData,
          operation: 'edit',
        })
      }

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanKomisaris',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaKomisaris',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneKomisaris',
        value:
          this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63
            ? 62
            : '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailKomisaris',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'komisarisLampiran',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'komisarisFiles',
        value: [],
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomisaris',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editKomisaris',
        value: false,
      })
    },
    fileKomisarisChangeHandler(e) {
      const file = e.target.files[0];
      const maxSize = 102400

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 100KB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      }
      else {
        let komisarisFiles = Array.from(e.target.files)
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'komisarisFiles',
          value: komisarisFiles,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
